var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.EnterpriseId)?_c('a-spin',{staticStyle:{"display":"block"}}):_c('div',{staticClass:"defaultIcon"},[(_vm.iconUrl && !_vm.imgError)?_c('img',{class:_vm.size,attrs:{"src":_vm.iconUrl},on:{"error":function($event){return _vm.loadDefault()}}}):_c('img',{staticClass:"img",attrs:{"src":require("@/assets/images/app_default_img.png")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18de4470","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/todoCenter/defaultIcon.vue
// module id = null
// module chunks = 